import { httpClient } from '@/core/api/client/httpClient'

interface FeaturesResponse {
  biometricPilotEnabled: boolean
  biometricPilotCedulas: string[]
}

interface BffFeaturesApiResponse {
  success: boolean
  data: FeaturesResponse | null
}

const SAFE_DEFAULT: FeaturesResponse = { biometricPilotEnabled: false, biometricPilotCedulas: [] }

export const configService = {
  async getFeatures(): Promise<FeaturesResponse> {
    try {
      const response = await httpClient.get<BffFeaturesApiResponse>('/api/config/features')
      if (response.success && response.data) return response.data
      return SAFE_DEFAULT
    } catch {
      return SAFE_DEFAULT
    }
  },
}
